import NotificationBanner from 'components/NotificationBanner/NotificationBanner'

export default NotificationBanner
